import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import Controls from '../../components/PosterFlow/Controls/Controls';
import Posters from '../../components/PosterFlow/Posters/Posters';
import Spinner from '../../components/UI/Spinner/Spinner';
import {
  fetchSchedule,
  filterSchedule,
} from '../../shared/store/actions';

const FILM_LIMIT = 10;

const PosterFlow = ({ schedule, fetchSchedule, filterSchedule }) => {
  const [showAll, setShowAll] = useState(false);
  const { filteredFilms, availableFilter, activeFilter } = schedule;
  const { loading, error } = schedule;

  const cutFilms = () => {
    return showAll
      ? filteredFilms
      : filteredFilms.filter((_, index) => index < FILM_LIMIT);
  };

  const toggleShowAll = (event) => {
    event.preventDefault();
    setShowAll((prevValue) => !prevValue);
  };

  useEffect(() => {
    fetchSchedule();
  }, [fetchSchedule]);

  useEffect(() => {
    if (activeFilter) {
      filterSchedule(activeFilter);
    }
  }, [filterSchedule, activeFilter]);

  if (loading) {
    return <Spinner />;
  }

  if (error) {
    return (
      <section className="section">
        <div className="text-center section__large">
          <p>{error}</p>
        </div>
      </section>
    );
  }

  return (
    <section className="section" id="program-grid">
      <Controls filters={availableFilter} activeFilter={activeFilter} />
      <Posters films={cutFilms(filteredFilms)} />
      {filteredFilms.length > FILM_LIMIT && (
        <div className="text-center section__large">
          <a onClick={toggleShowAll} href={null} style={{ cursor: 'pointer' }}>
            {showAll ? 'Weniger' : 'Alle'} Filme zeigen
          </a>
        </div>
      )}
    </section>
  );
};

const mapStateToProps = ({ schedule }) => ({ schedule });
const actions = {
  fetchSchedule: fetchSchedule,
  filterSchedule: filterSchedule,
};

export default connect(mapStateToProps, actions)(PosterFlow);
